export const loadingCopy = {
  labels: {
    accountSettings: 'Loading account settings...',
    builds: 'Loading builds...',
    coverageDirectories: 'Loading directories...',
    coverageFiles: 'Loading files...',
    coverageRuns: 'Loading coverage runs...',
    details: 'Loading details...',
    executionRuns: 'Loading execution runs...',
    features: 'Loading features...',
    flags: 'Loading flags...',
    jobs: 'Loading jobs...',
    resultsFiles: 'Loading results files...',
    metrics: 'Loading metrics...',
    page: 'Loading page...',
    pipelines: 'Loading pipelines...',
    preview: 'Loading preview...',
    projectSettings: 'Loading project settings...',
    releases: 'Loading releases...',
    stages: 'Loading stages...',
    stageExecutions: 'Loading stage executions...',
    suites: 'Loading suites...',
    suiteRuns: 'Loading suite runs...',
    tags: 'Loading tags...',
    tests: 'Loading tests...',
    testRuns: 'Loading test runs...',
    uploads: 'Loading uploads...',
    workspaceSettings: 'Loading workspace settings...',
  },
} as const;

export type LoadingCopyKey = keyof typeof loadingCopy.labels;

export const getLoadingMessage = (key: LoadingCopyKey): string => loadingCopy.labels[key];

export const getLoadingCopySamples = (): string[] => Object.values(loadingCopy.labels);
